import React from 'react';
import { useNavigate } from 'react-router-dom';  // ページ遷移用のフック
// 使用はグローバル CSS のクラス名に置換済み

function ToUpdateButton({ buttonText = "Update画面へ遷移", userId = null, disabled = false }) {  // 引数としてボタンのテキストと userId、disabled を受け取る
    const navigate = useNavigate();  // navigate関数を取得

    const handleClick = () => {
      if (disabled) return;
      // userId を整数に変換して渡す（受け側でそのまま number として受け取れる）
      const uid = (userId !== null && userId !== undefined) ? parseInt(userId, 10) : null;
      if (uid !== null && !Number.isNaN(uid)) {
        navigate('/update', { state: { userId: uid } });
      } else {
        navigate('/update');
      }
    };

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`btn ${disabled ? 'bg-gray-300 text-gray-500 cursor-not-allowed opacity-50' : 'btn--danger'}`}  // スタイルを適用
    >
        {buttonText}  {/* 引数で受け取ったテキストを表示 */}
    </button>
  );
}

export default ToUpdateButton;